export default __webpack_public_path__ + "static/media/toggle.a479786b.png";